// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.release-roles-tab {
  padding: 8px 4px 4px;
}

.creator-row {
  color: #0b2d71;
  margin-bottom: 8px;
}
.creator-row .username {
  font-family: "GothamBold", Arial, sans-serif;
}

.helper-copy {
  color: #707070;
  margin-top: 0;
  margin-bottom: 16px;
}

.members-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.member-group {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 12px;
  background-color: #fff;
}

.member-search,
.member-chips {
  display: grid;
  grid-template-columns: 190px 1fr;
  gap: 8px;
  align-items: start;
}

.member-chips {
  margin-top: 8px;
}

.field-label {
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  text-transform: lowercase;
}

.asterisk {
  color: #97002e;
  margin-left: 2px;
}

.placeholder {
  color: #8c8f93;
}

.actions-row {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.save-btn {
  border: none;
  border-radius: 4px;
  padding: 8px 14px;
  background-color: #0066b2;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: "Gotham", Arial, sans-serif;
}

.save-btn:disabled {
  background-color: #8c8f93;
  cursor: not-allowed;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

@media (max-width: 900px) {
  .member-search,
  .member-chips {
    grid-template-columns: 1fr;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
